import { useDispatch, useSelector } from 'react-redux';
import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './CartV2.css';
import { useEffect, useState } from 'react';
import CartList from '../../components/CartList/CartList';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { add } from '../../redux/cartSlice'
import { Tooltip } from '@mui/material';
import {
    SMALL_ORDER_SURCHARGE_THRESHOLD_EUR,
    SMALL_ORDER_SURCHARGE_EUR,
} from '../../pricing';
import { ClipLoader } from 'react-spinners';
import { formatMoney } from '../../utils/formatMoney';

const tip = (<div><strong>DELIVERY WILL BE DONE THE FOLLOWING WEEK WHEN WE RECEIVE THE PAYMENT UNTIL TUESDAY WEATHER AND CONDITIONS PERMITTING:</strong><br></br>
DELIVERIES AT ADDRESSES IN THE FOLLOWING LOCATIONS IN MALTA WILL BE DONE ON A TUESDAY AS PER THE INDICATED ROUTE:<br></br>
VALLETTA, SANTA VENERA,HAMRUN, PIETA,FLORIANA, MSIDA, TA'XBIEX, GZIRA, SLIEMA, ST.JULIANS, SAN GWANN, SWIEQI, MADLIENA, PEMBROKE, BAHAR IC-CAGHAQ<br></br><br></br>

DELIVERIES AT ADDRESSES IN THE FOLLOWING LOCATIONS IN MALTA WILL BE DONE ON A WEDNESDAY AS PER THE INDICATED ROUTE:<br></br>
 BIRKIRKARA, SWATAR, IKLIN, BALZAN, LIJA, ATTARD, MOSTA,NAXXAR, GHARGHUR, BURMARRAD, SAN PAWL IL-BAHAR, MELLIEHA, MANIKATA, MGARR,MTARFA, RABAT, DINGLI<br></br><br></br>

DELIVERIES AT ADDRESSES IN THE FOLLOWING LOCATIONS IN MALTA WILL BE DONE ON A THURSDAY AS PER THE INDICATED ROUTE:<br></br>
ZEBBUG, SIGGIEWI, QORMI, MARSA,BORMLA, BIRGU, ISLA, KALKARA, FGURA, PAOLA ,TARXIEN,SANTA LUCIJA, XGHAJRA,ZABBAR, MARSASCALA, ZEJTUN ,MARSAXLOKK, BIRZEBBUGIA, GHAXAQ ,GUDJA, KIRKOP ,MQABBA,SAFI ,ZURRIEQ, QRENDI,LUQA<br></br><br></br>

DELIVERIES AT ADDRESSES IN THE FOLLOWING LOCATIONS IN GOZO WILL BE DONE ON A FRIDAY AS PER THE INDICATED ROUTE:<br></br>
GHAJNSIELEM, QALA, XEWKIJA,NADUR, XAGHRA,SANNAT,KERCEM, MUNXAR,VICTORIA, FONTANA, XLENDI, GHARB,GHASRI, SAN LAWRENZ ,ZEBBUG ,MARSALFORN</div>);

const normalizeIkeaArticleId = (raw) => {
    const s = String(raw || '').trim();
    const stripped = s.replace(/^s/i, '');
    const digits = stripped.replace(/\D/g, '');
    return digits || stripped;
};

const CartV2 = () => {
    const cart = useSelector((state) => state.cartReducer.items)
    const [cartItems, setCartItems] = useState([]);
    const [stockLoading, setStockLoading] = useState(false);
    const [surcharge, setSurcharge] = useState(0);
    const [shipping, setShipping] = useState(0);
    const [VAT, setVAT] = useState(0);
    const [total, setTotal] = useState(0);
    const [addSKU, setAddSKU] = useState("");
    const [pickup, setPickup] = useState(false);

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const mapCartItems = async () => {
        if (cart.length === 0) {
            setCartItems([]);
            setStockLoading(false);
            return;
        }

        setStockLoading(true);

        try {
        const ikeaIds = [...new Set(
            cart.filter((item) => String(item.id).length <= 20).map((item) => normalizeIkeaArticleId(item.id)),
        )].filter(Boolean);

        let itemsMap = {};
        if (ikeaIds.length > 0) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API}/api/ikea/stock`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ articleIds: ikeaIds }),
                });
                const data = await response.json();
                if (data.items) {
                    itemsMap = data.items;
                }
            } catch (error) {
                console.error('Error fetching IKEA stock:', error);
            }
        }

        const items = cart.map((item) => {
            let stock = null;
            let probability = null;
            if (String(item.id).length <= 20) {
                const key = normalizeIkeaArticleId(item.id);
                const row = itemsMap[key];
                if (row?.ok) {
                    stock = row.stock;
                    probability = row.probability;
                }
            }
            return {
                id: item.id,
                name: item.name,
                price: item.price,
                img: item.img,
                amount: item.amount,
                stock,
                probability,
            };
        }).sort((a, b) => a.name.localeCompare(b.name));

        setCartItems(items);
        } finally {
            setStockLoading(false);
        }
    }

    useEffect(() => {
        mapCartItems();
    }, [cart]);
    

    useEffect(() => {
        calculateTotal(cart)
    }, [cart, pickup]);

    useEffect(() => {
        calculateVAT(cart)
    }, [surcharge]);

    useEffect(() => {
        calculateVAT(cart)
    }, [shipping]);

    const calculateTotal = (cart) => {
        let sum = 0;

        cart.forEach(item => {
            sum += (item.price * item.amount)
        });

        setTotal(sum);
        calculateSurcharge(cart);
    }

    const calculateSurcharge = (cart) => {
        let sum = 0;

        cart.forEach(item => {
            sum += (item.price * item.amount)
        });

        if (sum === 0) setSurcharge(0)
        else if (pickup) setSurcharge(0)
        else if (sum < SMALL_ORDER_SURCHARGE_THRESHOLD_EUR) setSurcharge(SMALL_ORDER_SURCHARGE_EUR)
        else setSurcharge(0)
        calculateShipping(cart);
    }

    const calculateShipping = (cart) => {
        let sum = 0;

        cart.forEach(item => {
            sum += (item.price * item.amount)
        });

        if (sum > 500) setShipping(sum * 0.28)
        else setShipping(sum * 0.30, () => calculateVAT(cart))
    }

    const calculateVAT = (cart) => {
        let sum = 0;

        cart.forEach(item => {
            sum += (item.price * item.amount)
        });

        setVAT((sum + surcharge + shipping) / 1.18 * 0.18);
    }

    const handleChangeAdd = (e) => {
        setAddSKU(e.target.value);
    }

    const handleAdd = () => {
        fetch(`${process.env.REACT_APP_API}/api/getProductsByName/${addSKU.trim()}/0/10`, {})
        .then((response) => response.json())
        .then((responseData) => {
            if (responseData.length > 0) {
                handleAddItem({
                    id: responseData[0].id,
                    name: responseData[0].name,
                    price: responseData[0].price.currentPrice,
                    img: responseData[0].image,
                    amount: 1,
                })
            } else {
                toast.error(`${addSKU} not found!`, {
                    toastId: Math.floor(Math.random() * 100000),
                })
            }
        })
        .catch(error => console.warn(error));
    }

    const handleAddItem = (data) => {
        dispatch(add({
            id: data.id,
            name: data.name,
            price: data.price,
            img: data.img,
            amount: data.amount,
        }))

        toast.success(`${data.name} added to cart!`, {
            toastId: Math.floor(Math.random() * 100000),
        })
    
        setAddSKU("")
    }
    
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
          handleAdd();
        }
    };

    return (
        <div className="v2-page cartv2">
            <NavbarV2 />

            <div className="v2-container cartv2-inner">
                <div className="cartv2-grid">
                    <div className="cartv2-col cartv2-col--list">
                        <div className="v2-inline-input">
                            <input
                                type="text"
                                value={addSKU}
                                onChange={(e) => handleChangeAdd(e)}
                                placeholder="SKU or product name…"
                                onKeyDown={handleKeyDown}
                            />
                            <button type="button" className="v2-btn v2-btn--outline" onClick={handleAdd}>
                                Add to cart
                            </button>
                        </div>

                        {stockLoading && (
                            <p className="v2-muted cartv2-stock-msg">
                                <ClipLoader color="#C4603C" size={14} />
                                Checking stock…
                            </p>
                        )}

                        <div className="v2-mui-scope cartv2-mui">
                            <CartList data={cartItems} noMargin={true} showcase={false} stockLoading={stockLoading} />
                        </div>
                    </div>

                    <div className="v2-card cartv2-summary">
                        <h2 className="v2-card-title">Order summary</h2>
                        <p className="v2-muted" style={{ marginTop: '-8px', marginBottom: '12px' }}>
                            All prices include VAT where applicable.
                        </p>

                        <label className="v2-note v2-callout">
                            <input
                                type="checkbox"
                                checked={pickup}
                                onChange={(e) => setPickup(e.target.checked)}
                            />
                            {total < SMALL_ORDER_SURCHARGE_THRESHOLD_EUR ? (
                                <span>
                                    Warehouse pickup — waive the €{SMALL_ORDER_SURCHARGE_EUR} small-order surcharge
                                    only (orders under €{SMALL_ORDER_SURCHARGE_THRESHOLD_EUR} product total). Shipping
                                    to our warehouse still applies.
                                </span>
                            ) : (
                                <span>Pick up</span>
                            )}
                        </label>

                        <div className="v2-price-row">
                            <p>Products</p>
                            <h4>€{formatMoney(total)}</h4>
                        </div>
                        <div className="v2-price-row">
                            <p>Shipping</p>
                            <h4>€{formatMoney(shipping)}</h4>
                        </div>
                        <div className="v2-price-row">
                            <p>Surcharge</p>
                            <h4>€{formatMoney(surcharge)}</h4>
                        </div>
                        <div className="v2-divider" />
                        <div className="v2-price-row v2-grand-total">
                            <p>Grand total</p>
                            <h4>€{formatMoney(total + surcharge + shipping)}</h4>
                        </div>

                        <div className="cartv2-submit">
                            <button
                                type="button"
                                className="v2-btn v2-btn--primary"
                                disabled={total === 0}
                                onClick={() => navigate('/order', { state: { pickup } })}
                            >
                                Continue to checkout
                            </button>
                        </div>

                        <div className="cartv2-legal">
                            <p className="v2-muted">
                                The items you order will be delivered as soon as possible depending on shop stock —
                                email us if you need a firm date.
                            </p>
                            <p className="v2-muted">
                                Delivery{' '}
                                <Tooltip disableFocusListener title={tip} placement="top">
                                    <span className="cartv2-schedule-link">schedule</span>
                                </Tooltip>
                                {' '}(regions and weekdays).
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CartV2;